import { toCamelCase } from "@bonusmap/shared_ui/library";
import { HelpWindow } from "../web-components/help-window/help-window.js";
import { Delegate } from "./Delegate.js";
import { helpContent } from "./helpContent.js";


export class HelpSystem {
    private static instance: HelpSystem;
    private helpsCache: Record<string, HelpWindow>;

    private constructor() {
        this.helpsCache = {};
        this.init();
    }
    public showHelp(helpTopicId: string): void {
        const help = this.helpsCache[helpTopicId];
        if (help) {
            help.show();
            return;
        }
        const txt = helpContent(helpTopicId);
        if (!txt || txt === '') {
            console.warn(`Help content for topic '${helpTopicId}' not found`);
            return;
        }
        const helpControl = HelpWindow.create(txt);
        this.helpsCache[helpTopicId] = helpControl;
    }

    private init() {
        Delegate.on('click', 'a[help]', (event: Event) => {
            const target = event.target as HTMLElement;
            const helpTopicId = target.getAttribute('help');
            if (helpTopicId) {
                event.preventDefault();
                this.showHelp(toCamelCase(helpTopicId));
            }
        });
    }
    public static register(): HelpSystem {
        if (!HelpSystem.instance) {
            HelpSystem.instance = new HelpSystem();
        }
        return HelpSystem.instance;
    }

    
}